<i18n>
{
  "fr": {
    "Export": "Exporter en Excel",
    "Title": "Rapport des activités d'analyse prévente",
    "PreSaleAnalysisActivities": "Activités d'analyse prévente",
    "ForOpportunitiesWithStatus": "pour les opportunités ayant un statut"
  }
}
</i18n>

<template>
  <section>
    <AppHeader
      :title="$route.query.opportunityStatus ? $t('Title')
        + ' ' + $t('ForOpportunitiesWithStatus')
        + ': ' + getOpportunityNameById($route.query.opportunityStatus)
      : $t('Title')">
      <div class="row justify-content-end">
        <div class="col-auto">
          <ButtonExport
            :label="$t('Export')"
            @click="exportToExcel()"/>
        </div>
      </div>
    </AppHeader>
    <AppContainer>
      <BaseTabs slot="left">
        <BaseTab
          :to="{
            name: 'PreSaleAnalysisActivities',
            query: $route.query
          }"
          :label="$t('PreSaleAnalysisActivities')" />
      </BaseTabs>
      <router-view :key="$route.fullPath" />
    </AppContainer>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    mapGetters,
  },
  computed: {
    ...mapGetters('opportunities', ['getOpportunityNameById']),
  },
  created() {
    this.$store.dispatch('activities/getPreSaleAnalysisActivities', this.$route.query);
  },
  methods: {
    exportToExcel() {
      this.$store.dispatch('activities/exportToExcel');
    },
  },
};
</script>
